export const getCustomAppStatusBadgeStyles = (status) => {
  const statusKey = status?.toLowerCase() || "unknown";

  const statusStyles = {
    running: {
      className: "border-emerald-200 bg-emerald-50 text-emerald-700 shadow-2xs",
      dotClass: "bg-emerald-500 animate-pulse",
      glowClass: "shadow-[0_0_8px_rgba(16,185,129,0.4)]",
      label: "Running",
    },
    draft: {
      className: "border-slate-200 bg-slate-100 text-slate-600",
      dotClass: "bg-slate-400",
      glowClass: "",
      label: "Draft",
    },
    deploying: {
      className: "border-amber-200 bg-amber-50 text-amber-700 shadow-2xs",
      dotClass: "bg-amber-500 animate-ping",
      glowClass: "shadow-[0_0_8px_rgba(245,158,11,0.4)]",
      label: "Deploying",
    },
    error: {
      className: "border-rose-200 bg-rose-50 text-rose-700 shadow-2xs",
      dotClass: "bg-rose-500",
      glowClass: "",
      label: "Error",
    },
    failed: {
      className: "border-rose-200 bg-rose-50 text-rose-700 shadow-2xs",
      dotClass: "bg-rose-500",
      glowClass: "",
      label: "Failed",
    },
  };

  return (
    statusStyles[statusKey] || {
      className: "border-slate-200 bg-slate-50 text-slate-600",
      dotClass: "bg-slate-400",
      glowClass: "",
      label: status || "Unknown",
    }
  );
};

export const getCustomAppTypeBadgeStyles = (type) => {
  const typeKey = type?.toLowerCase() || "general";

  const typeStyles = {
    frontend: {
      className: "border-sky-200 bg-sky-50 text-sky-700 font-medium",
      label: "Frontend",
    },
    fullstack: {
      className: "border-violet-200 bg-violet-50 text-violet-700 font-medium",
      label: "Fullstack",
    },
    mern: {
      className: "border-indigo-200 bg-indigo-50 text-indigo-700 font-medium",
      label: "MERN Stack",
    },
  };

  return (
    typeStyles[typeKey] || {
      className: "border-slate-200 bg-slate-50 text-slate-600 font-medium",
      label: type || "Application",
    }
  );
};

export const getAppInitials = (name) => {
  if (!name) return "CA";
  // Remove special characters and hyphens
  const cleaned = name.replace(/[^a-zA-Z0-9\s]/g, " ").trim();
  const words = cleaned.split(/\s+/).filter(Boolean);
  if (words.length === 0) return "CA";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

export const getAppGradient = (name = "") => {
  const gradients = [
    "from-indigo-600 via-indigo-700 to-purple-800 text-white",
    "from-violet-600 via-purple-600 to-indigo-800 text-white",
    "from-blue-600 via-sky-600 to-cyan-700 text-white",
    "from-emerald-600 via-teal-600 to-cyan-800 text-white",
    "from-purple-600 via-fuchsia-600 to-pink-700 text-white",
    "from-rose-600 via-pink-600 to-purple-700 text-white",
  ];

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % gradients.length;
  return gradients[index];
};

export const formatByteSize = (bytes) => {
  if (!bytes || isNaN(bytes)) return "0 B";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

export const customAppStatuses = [
  { key: "All Statuses", value: "all" },
  { key: "Running", value: "running" },
  { key: "Deploying", value: "deploying" },
  { key: "Draft", value: "draft" },
  { key: "Error", value: "error" },
];

export const customAppTypes = [
  { key: "All Types", value: "all" },
  { key: "Fullstack", value: "fullstack" },
  { key: "Frontend", value: "frontend" },
];
